
import superagent from "superagent";
import { CookieWrap as Cookies } from "../../helper/cookie-wrap";
import {AUTH_RESPONSE_STATE, LOGIN_NEW_PASSWORD, LOGIN_SUCCESS} from "../../../lib/constants";
import { NAVIGATE_PATH } from "../../nav/actions";
import { AccountState } from "../../../lib/constants";
import { DATA_TO_STORE } from "../../onboarding/actions";
import { DWOLLA_UPDATE } from "../../payment/actions";
import {authorize, authorize_onboarding} from "../../helper/authorize-token";
import { sprintf } from "sprintf-js";
import {TDA_UPDATE} from "../../tda/actions";
import { INBOX_SET_UNREAD_COUNT } from "../../inbox/actions";
import {deep_copy} from "../../../lib/js-utils";

const LOGIN_DO_PENDING = "LOGIN_DO_PENDING";
const LOGIN_SET_2FA_STATE = "LOGIN_SET_2FA_STATE";
const LOGIN_RESEND_OTP = "LOGIN_RESEND_OTP";
const LOGIN_DO_FULFILLED = "LOGIN_DO_FULFILLED";
const LOGIN_DO_FULFILLED_2 = "LOGIN_DO_FULFILLED_2";
const LOGIN_DO_NEW_PASSWORD = "LOGIN_DO_NEW_PASSWORD";
const LOGIN_DO_REJECTED = "LOGIN_DO_REJECTED";
const LOGIN_DO_LOGOUT = "LOGIN_DO_LOGOUT";
const LOGIN_SET_FETCHING = "LOGIN_SET_FETCHING";
const LOGIN_SET_ERROR = "LOGIN_SET_ERROR";
const LOGIN_SET_ACCOUNT_STATE = "LOGIN_SET_ACCOUNT_STATE";
const LOGIN_SET_ONBOARDING_TOKEN = "LOGIN_SET_ONBOARDING_TOKEN";
const LOGIN_SET_USER = "LOGIN_SET_USER";
const UPDATE_USER_ACCT_INDEX = "UPDATE_USER_ACCT_INDEX";
const UPDATE_USER_NAME = "UPDATE_USER_NAME";

const copy_account_states = (dest, source) => {
  const stateRE = /^account_[0-9]{4}_state$/;

  Object.keys(source).forEach(prop => {
    if (stateRE.test(prop)) {
      dest[prop] = source[prop];
    }
  })
};

const loginSetUser = user => {
  return dispatch => {
    dispatch({
      type: LOGIN_SET_USER,
      user,
    })
  }
}

const updateUserAcctIndex = acct_index => {
  return dispatch => {
    dispatch({
      type: UPDATE_USER_ACCT_INDEX,
      acct_index,
    })
  }
}

const array_to_map = arr => {
  const result = {};

  arr.forEach(item => {
    const key = item.id.split("_").pop();
    result[key] = item;
  });

  return result;
}

const handleLoginResults = (dispatch, response, email) => {

  const result_status = response.response;
  const username = response.username;

  if (result_status === LOGIN_SUCCESS
    || result_status === AUTH_RESPONSE_STATE.SUCCESS) {
    const {
      token,
      account_type,
      account_state,
      identity_id,
      name,
      id,
      loaded_acct_index,
      refresh_token,
      onboarding,
      tda,
      dwolla,
      email,
    } = response;
    const cookie = new Cookies();
    cookie.set("refresh", refresh_token, { path: '/' });
    cookie.set("token", token, { path: '/' });
    cookie.set("user_wlf_id", username, { path: '/' });
    dispatch({
      type: DWOLLA_UPDATE,
      data: array_to_map(dwolla),
      index: -1,
    });
    if (onboarding) {
      dispatch({
        type: DATA_TO_STORE,
        data: array_to_map(onboarding),
        index: -1,
      })
    }
    if (tda) {
      dispatch({
        type: TDA_UPDATE,
        data: array_to_map(tda),
        index: -1,
      })
    }
    if (email) {
      dispatch({
        type: INBOX_SET_UNREAD_COUNT,
        unread_count: email.unread_count,
      })
    }
    const login_body = {
      type: LOGIN_DO_FULFILLED,
      name,
      id,
      username,
      identity_id,
      account_type,
      account_state,
      token,
      loaded_acct_index,
    };
    copy_account_states(login_body, response);
    dispatch(login_body);
  } else if (
    result_status === LOGIN_NEW_PASSWORD
    || result_status === AUTH_RESPONSE_STATE.NEW_PASSWORD_REQUIRED) {
    dispatch({
      type: LOGIN_DO_NEW_PASSWORD,
      session: response.session,
      user_name: email,
      username,
    });
    dispatch({
      type: NAVIGATE_PATH,
      payload: "/new_password",
    });
  }
};

const setError = error => {
  return dispatch => {
    dispatch({
      type: LOGIN_SET_ERROR,
      error,
    })
  }
}

const setPassword = (token, password, username) => {
  return new Promise(resolve => {
    superagent.agent()
      .post("/api/auth/set-password")
      .use(authorize(token))
      .send({ password, username })
      .then(res => {
        return resolve(res);
      });
  })
}

const setPasswordFromSession = (passwd) => {
  return (dispatch, getState) => {
    const {session, username} = getState().user;
    dispatch({
      type: LOGIN_SET_FETCHING,
      isFetching: true,
    });
    superagent
      .post("/api/auth/set-password-from-session")
      .send({ username, passwd, session })
      .then(res => {
        const resp = res.body.data;
        dispatch({
          type: LOGIN_SET_FETCHING,
          isFetching: false,
        });

        if (resp.status === "OK") {
          handleLoginResults(dispatch, resp.payload);
        } else {
          dispatch({
            type: LOGIN_SET_ERROR,
            error: resp.error,
          })
        }
      });
  }
}

const UGMALogin = (wlf_id, token) => {
  return dispatch => {
    dispatch({ type: LOGIN_DO_PENDING });
    return superagent
      .post("/api/auth/ugma-login")
      .send({ wlf_id, token })
      .then(res => {
        const result = res.body.data;
        if (result.success) {
          dispatch({
            type: DWOLLA_UPDATE,
            data: result.dwolla,
            index: -1,
          });
          dispatch({
            type: LOGIN_DO_FULFILLED_2,
            user: result.user,
          });
        } else {
          dispatch({
            type: LOGIN_DO_REJECTED,
            payload: "Invite token expired",
          });
        }
      })
  }
}

const resendOTP = () => {
  return (dispatch, getState) => {
    const username = getState().user.username;
    dispatch({
      type: LOGIN_DO_PENDING,
      isFetching: false,
      otp_sending: true,
    });
    dispatch({
      type: LOGIN_RESEND_OTP,
      payload: superagent
        .post("/api/auth/two-factor-resend-otp")
        .send({username}),
    })

  }
}
const twoFAotp = otp => {
  return (dispatch, getState) => {
    const username = getState().user.username;
    dispatch({ type: LOGIN_DO_PENDING});
    superagent.agent()
      .post("/api/auth/two-factor-otp")
      .send({username, otp})
      .then(res => {
        const resp = res.body.data;
        let error_str;
        if (resp.status === "ERROR") {
          error_str = "There was an error"
        } else {
          error_str = responseToError(resp.payload.response);
        }
        if (error_str) {
          dispatch({
            type: LOGIN_DO_REJECTED,
            payload: error_str,
          });
        } else {
          handleLoginResults(dispatch, resp.payload);
        }
      })
  }
}

const twoFALoginCall = (dispatch, username, passwd) => {
  dispatch({ type: LOGIN_DO_PENDING});
  superagent.agent()
    .post("/api/auth/two-factor-login")
    .send({ username, passwd })
    .then(res => {
      let error_str, login_state;
      const resp = res.body.data;
      if (resp.status === "ERROR") {
        error_str = "There was an error"
      } else {
        error_str = responseToError(resp.payload.response);
      }
      if (resp.status === "OK") {
        login_state = resp.payload.state;
      }

      dispatch({
        type: LOGIN_SET_2FA_STATE,
        state: login_state,
        username,
        error: error_str,
      });
      dispatch({
        type: LOGIN_SET_FETCHING,
        isFetching: false,
      });
      if (resp.payload.response === AUTH_RESPONSE_STATE.NEW_PASSWORD_REQUIRED) {
        handleLoginResults(dispatch, resp.payload);
      } else if (resp.payload.response === AUTH_RESPONSE_STATE.SUCCESS) {
        handleLoginResults(dispatch, resp.payload);
      }
    });
}

const twoFAlogin = (username, passwd) => {
  return dispatch => {
    dispatch({ type: LOGIN_DO_PENDING});
    superagent.agent()
      .post("/api/auth/get-two-factor-metadata")
      .send({username})
      .then(res => {
        const resp = res.body.data;
        if (resp.status === "ERROR") {
          dispatch({
            type: LOGIN_DO_REJECTED,
            payload: "There was an error",
          });
        } else {
          dispatch({
            type: LOGIN_SET_2FA_STATE,
            state: resp.payload.state,
            username,
          });

          if (resp.payload.state === "START") {
            twoFALoginCall(dispatch, username, passwd);
          } else {
            dispatch({
              type: LOGIN_SET_FETCHING,
              isFetching: false,
            });
          }
        }
      })
  }
}

const cognitoLogin = (user_name, wlf_id, passwd) => {
  return dispatch => {
    dispatch({ type: LOGIN_DO_PENDING });
    return superagent
      .post("/api/auth/login-old")
      .send({
        user_name, wlf_id, passwd
      })
      .then(res => {
        handleLoginResults(dispatch, res.body.data, user_name);
      })
      .catch(err => {
        let text = "";
        const code = err.response.body.error;
        if (code === "TOO_MANY_LOGIN_FAILURES") {
          text = "Too Many Failed Logins";
        } else {
          text = "Invalid Username or Password";
        }
        dispatch({
          type: LOGIN_DO_REJECTED,
          payload: text,
        });
      })
  }
};

const onboardingLogin = (
  name, username, account_type, onboarding_token, token, identity_id) => {
  return dispatch => {

    const action = {
      type: LOGIN_DO_FULFILLED,
      name: name,
      account_type: account_type,
      onboarding_token: onboarding_token,
      username,
      token,
      identity_id,
      loaded_acct_index: 0,
      account_state: {
        '0000': AccountState.ONBOARDING,
      }
    };
    dispatch(action);
  }
};

const setCognitoAccountState = (token, onboarding_token, account_state, index) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/auth/set-account-state")
      .send({ account_state, index})
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  });
};

const decodeToken = token => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/auth/decode-token")
      .send({ token })
      .then(result => {
        resolve(result.body.data);
      })
  })
}

const setAccountState = (account_state, index, token, onboarding_token) => {

  return (dispatch) => {
    dispatch({
      type: LOGIN_SET_ACCOUNT_STATE,
      account_state: account_state,
      index: index,
      token,
      onboarding_token,
    });
  }
};

// Get rid of the cognito token and replace with the
// onboarding token
const createOnboardingToken = (token) => {
  return dispatch => {
    return superagent
      .post("/api/onboarding/create-onboarding-token")
      .use(authorize(token))
      .then(res => {
        const data = res.body.data;
        dispatch({
          type: LOGIN_SET_ONBOARDING_TOKEN,
          onboarding_token: data.onboarding_token,
        });
      })
  }
};

const resetPassword = (wlf_id, email) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/auth/reset-password")
      .send({ wlf_id, email })
      .then(() => {
        resolve();
      })
  });
};

const updateUserName = (token, onboarding_token, first_name, last_name) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/update-name")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ first_name, last_name})
      .then(resolve);
  })
}

const updateUserNameRedux = (first_name, last_name, onboarding_token) => {
  return dispatch => {
    dispatch({
      type: UPDATE_USER_NAME,
      first_name,
      last_name,
      onboarding_token,
    });
  }
}

const logout = () => {
  return dispatch => {
    dispatch({
      type: LOGIN_DO_LOGOUT,
    });
  }
}

const responseToError = resp_state => {
  if (resp_state === AUTH_RESPONSE_STATE.USERNAME_DOES_NOT_EXIST) {
    return "Email not found";
  } else if (resp_state === AUTH_RESPONSE_STATE.TOO_MANY_ATTEMPTS) {
    return "Too many login attempts";
  } else if (resp_state === AUTH_RESPONSE_STATE.TOO_MANY_OTP_FAIL) {
    return "Too many OTP failures";
  } else if (resp_state === AUTH_RESPONSE_STATE.PASSWORD_FAIL) {
    return "Password incorrect";
  } else if (resp_state === AUTH_RESPONSE_STATE.OTP_FAIL) {
    return "Passcode incorrect";
  }
  return null;
}

const loginReducer = (
  state = {
    isFetching: false,
    otp_sending: false,
    error: null,
  },
  action)  => {
  let login_state, error_str, new_state;

  switch (action.type) {
    case LOGIN_SET_USER:
      return action.user;

    case "LOGIN_DO_PENDING":
      return {
        ...state,
        otp_sending: !!action.otp_sending,
        isFetching: 'isFetching' in action ? !!action.isFetching : true,
        error: null
      };
    case LOGIN_DO_NEW_PASSWORD:
      return {
        ...state,
        isFetching: false,
        session: action.session,
        user_name: action.user_name,
        username: action.username,
      };
    case LOGIN_SET_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    case LOGIN_SET_ACCOUNT_STATE:
      const prop = sprintf("%04d", action.index);
      new_state = deep_copy(state);
      new_state.account_state[prop] = action.account_state;
      return new_state;
    case LOGIN_SET_ONBOARDING_TOKEN:
      return {
        ...state,
        token: undefined,
        confirmed: false,
        identity_id: undefined,
        onboarding_token: action.onboarding_token,
      };
    case LOGIN_RESEND_OTP + "_FULFILLED":
      const llres = action.payload.body.data;
      login_state = state.login_state;
      if (llres.status === "OK") {
        login_state = llres.payload.state;
      } else {
        error_str = "An error occurred";
      }
      return {
        ...state,
        login_state,
        error: error_str,
        isFetching: false,
      }
    case LOGIN_SET_2FA_STATE:
      return {
        ...state,
        login_state: action.state,
        username: action.username,
        error: action.error,
      }
    case "LOGIN_DO_FULFILLED":
      const result = {
        ...state,
        isFetching: false,
        error: null,
        name: action.name,
        id: action.id,
        username: action.username,
        account_type: action.account_type,
        account_state: action.account_state,
        identity_id: action.identity_id,
        loaded_acct_index: action.loaded_acct_index,
        token: action.token,
        onboarding_token: action.onboarding_token,
        session: "",
        login_state: null,
      };
      copy_account_states(result, action);
      return result;
    case LOGIN_DO_FULFILLED_2:
      return {
        ...state,
        ...action.user,
        session: "",
      }
    case "LOGIN_DO_REJECTED":
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case "LOGIN_DO_LOGOUT":
      return {
        isFetching: false,
        error: null,
      };
    case "LOGIN_SET_ERROR":
      return {
        ...state,
        error: action.error,
      };
    case UPDATE_USER_ACCT_INDEX:
      return {
        ...state,
        loaded_acct_index: action.acct_index,
      };
    case UPDATE_USER_NAME:
      const { first_name, last_name } = action;
      new_state = {
        ...state,
        name: first_name + " " + last_name,
      }
      if (action.onboarding_token) {
        new_state.onboarding_token = action.onboarding_token;
      }
      return new_state;
    default:
      return state;
  }
}

export { loginReducer, cognitoLogin, logout, onboardingLogin,
  setAccountState, createOnboardingToken,
  setCognitoAccountState, decodeToken, updateUserAcctIndex,
  resetPassword, setError, UGMALogin, updateUserName,
  updateUserNameRedux, loginSetUser, twoFAlogin, twoFAotp,
  setPasswordFromSession, resendOTP, setPassword };
